import { render, staticRenderFns } from "./scormContent.vue?vue&type=template&id=4f3cfc20&"
import script from "./scormContent.vue?vue&type=script&lang=js&"
export * from "./scormContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports